function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M379.577,247.395c-14.944-18.75-31.833-28.12-50.679-28.12V73.092c9.896,0,18.47-3.616,25.693-10.848 c7.238-7.233,10.858-15.802,10.858-25.697c0-9.9-3.62-18.464-10.858-25.697C347.368,3.617,338.795,0,328.898,0H146.179 c-9.9,0-18.464,3.617-25.697,10.85c-7.234,7.233-10.85,15.796-10.85,25.697c0,9.899,3.616,18.464,10.85,25.697 c7.233,7.232,15.8,10.848,25.697,10.848v146.179c-18.844,0-35.734,9.374-50.677,28.123c-14.941,18.75-22.414,39.824-22.414,63.242 c0,4.948,1.809,9.232,5.426,12.847c3.619,3.613,7.901,5.421,12.85,5.421h115.344l21.698,138.474 c0.95,5.141,3.996,7.707,9.135,7.707h0.291c2.274,0,4.235-0.808,5.851-2.423c1.615-1.619,2.614-3.572,2.994-5.855l14.558-137.902 h122.482c4.948,0,9.236-1.808,12.847-5.421c3.621-3.614,5.432-7.898,5.432-12.847C401.999,287.222,394.519,266.145,379.577,247.395 z M210.132,210.14c0,2.662-0.855,4.849-2.57,6.565c-1.713,1.714-3.903,2.57-6.567,2.57c-2.662,0-4.853-0.855-6.567-2.57 c-1.713-1.713-2.568-3.903-2.568-6.565V82.233c0-2.664,0.855-4.858,2.568-6.567c1.714-1.711,3.905-2.568,6.567-2.568 c2.664,0,4.854,0.854,6.567,2.568c1.714,1.712,2.57,3.903,2.57,6.567V210.14z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgPin = function SvgPin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 475.085 475.085",
    style: {
      enableBackground: "new 0 0 475.085 475.085"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pin.f1525c45.svg";
export { ForwardRef as ReactComponent };